<template>
  <div class="mb-100">
    Text Edittor
    <quill-editor
      ref="editor"
      class="mwe-texteditor-editor editor"
      :content="content"
      :options="options"
      @focus="onEditorFocus"
      @blur="onEditorBlur"
      @change="onEditorChange"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import { QuillEditor } from '@vueup/vue-quill'
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css"; // import styles
// import "quill/dist/quill.bubble.css"; // import styles
// import "quill/dist/quill.snow.css"; // import styles
// import Quill from "quill";
// import '@vueup/vue-quill/dist/vue-quill.snow.css';

export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      // content: '<h3 class="ql-align-left"><span style="font-size: 40px; color: rgb(0, 0, 0);">How we improved the E-Learning experience for </span><span style="font-size: 40px; color: rgb(0, 0, 255);">Makro</span><span style="font-size: 40px; color: rgb(0, 255, 0);"> HORECA Academy</span></h3>',
      // content: '<h3 class="ql-align-left"><span style="font-size: 40px; color: rgb(0, 255, 0);">ABC</span><span style="font-size: 40px; color: rgb(0, 255, 255);">ABC</span></h3>',
      content: 'ABCABC',
    }
  },
  computed: {
    ...mapGetters({
    }),
    options() {
      return {
        theme: "bubble",
      }
    }
  },
  methods: {
    onEditorFocus(e) {
      e
    },
    onEditorBlur(e) {
      e
    },
    onEditorChange(e) {
      e
    }
  },
};
</script>

<style></style>